import {DataType, SourceIds, TimeRange, TimeResolution} from "@flowmaps-com/flowmaps-typescriptmodels";
import {IncidentOption} from "../charts/base-measurement-chart";

export interface Dashboard {
    dashboardId?: any;
    info?: DashboardInfo;
}

export interface DashboardInfo {
    type?: DashboardType;
    chartOptions?: { [P in ChartOptionType]?: ChartOptions };
    name?: any;
    predefinedTimeRange?: string;
    resolution?: TimeResolution;
    timeRange?: TimeRange;
    sources?: SourceIds;
}

export interface ChartOptions {
    compare?: ChartCompare;
    nettedConsumption?: boolean;
    selectedWeatherTypes?: DataType[];
    showAsTable?: boolean;
    showPower?: boolean;
    showFeedInPower?: boolean;
    showPowerForEan?: string;
    groupByEntityIdPossible?: boolean;
    groupByEntityId?: boolean;
    showReactive?: boolean;
    showCompleteness?: boolean;
    showConsumption?: boolean;
    showChargePoints?: boolean;
    showFeedIn?: boolean;
    showGrossProduction?: boolean;
    splitOffPeak?: boolean;
    showBySquareMeter?: boolean;
    locationRankingName?: LocationRankingName;
    showUncorrectedConsumption?: boolean;
    showConsumptionPerDegreeDay?: boolean;
    gasConsumptionView?: GasConsumptionView;
    showCooling?: boolean;
    /** Read legacy saved dashboards; new controls use showCooling. */
    thermalConsumptionView?: 'heating' | 'cooling';
    showOpeningHoursSplit?: boolean;
    showWeekendWeekdaySplit?: boolean;
    showHourlyEnergyProfile?: boolean;
    selectedDataType?: DataType;
    showAllDays?: boolean;
    selectedDays?: string[];
    officialHolidaysOnly?: boolean;
    showIncidents?: boolean;
    selectedIncidents?: IncidentOption[];
    meterTreeView?: MeterTreeViewOptions;
}

export type GasConsumptionView = 'actual' | 'climateNormalized' | 'compareClimate';

export interface MeterTreeViewOptions {
    selectedTagFilters?: Record<string, string | null>;
    selectedMeterName?: MeterTreeName;
    showAsTable?: boolean;
}

export enum MeterTreeName {
    Name = "Name",
    SourceMeterNumber = "Source meter number",
    Tenant = "Tenant"
}

export enum LocationRankingName {
    Address = "Address",
    Name = "Name",
    Object = "Object"
}

export interface ChartCompare {
    comparedYear?: number;
    enabled?: boolean;
    relative?: boolean;
}

export const enum DashboardType {
    Portfolio = "Portfolio",
    Location = "Location",
}

export const enum ChartOptionType {
    Electricity = "Electricity",
    Gas = "Gas",
    Water = "Water",
    Heat = "Heat",
    ChargePoint = "ChargePoint",
    Performance = "Performance",
    DaysOfWeek = "DaysOfWeek",
    EnergyProfile = "EnergyProfile"
}
